import { Component, OnInit } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color, Label } from 'ng2-charts';

import {dataLineEnergy, dataLineCost, dataLabelTime, sessionDate, stationName} from '../data0723b';

@Component({
  selector: 'app-line-chart-b',
  templateUrl: './line-chart-b.component.html',
  styleUrls: ['./line-chart-b.component.scss']
})
export class LineChartBComponent implements OnInit {

  StationName = stationName;
  SessionDate = sessionDate;

  public lineChartData: ChartDataSets[] = [
    //{ data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
    dataLineEnergy, dataLineCost
  ];
  public lineChartLabels: Label[] = dataLabelTime;
  //public lineChartLabels: Label[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

  public lineChartOptions: ChartOptions = {
    responsive: true,
  };
    public lineChartColors: Color[] = [
      {
        backgroundColor: 'rgba(0,0,255,0.4)',
      borderColor: 'rgba(0,0,255,0.4)',
      },
      {
        backgroundColor: 'rgba(255,0,255,0.4)',
      borderColor: 'rgba(255,0,255,0.4)',
      }
    ];
  public lineChartLegend = true;
  public lineChartType: ChartType = 'line';
  public lineChartPlugins = [];

  constructor() { }

  ngOnInit() {
  }

}
